export const camelToSnakeCase = (text: string): string => {
  return text.replace(/([A-Z])/g, "_$1").toLowerCase();
};
